export const AFM_ALGORITHMS = ['Three pairs', 'Six-operator stack', 'Five modulators', 'Two stacks', 'Twin branches', 'Six carriers', 'Branching stack', 'Hybrid pairs'];
export const defaultAfmOperators = () => Array.from({ length: 6 }, (_, i) => ({
  ratio: i % 2 ? 2 : 1, mode: 'ratio', frequency: 440, detune: 0,
  level: i % 2 ? 0.55 : 0.8, feedback: 0, wave: 0,
  attack: 0.005, decay: i % 2 ? 0.5 : 1, sustain: i % 2 ? 0.15 : 0.65,
  release: 0.3, velocity: 0.6
}));
export function normalizeAfm(candidate = {}) {
  const clamp = (v, lo, hi, fallback) => Number.isFinite(Number(v)) ? Math.min(hi, Math.max(lo, Number(v))) : fallback;
  return { algorithm: Math.round(clamp(candidate.algorithm, 0, 7, 0)),
    operators: defaultAfmOperators().map((base, i) => {
      const op = candidate.operators?.[i] || {};
      const result = { ...base, mode: op.mode === 'fixed' ? 'fixed' : 'ratio' };
      for (const [key, lo, hi] of [['ratio',0.125,32],['frequency',1,20000],['detune',-100,100],['level',0,1],['feedback',0,1],['attack',0.001,8],['decay',0.001,8],['sustain',0,1],['release',0.005,12],['velocity',0,1],['wave',0,2]]) result[key] = clamp(op[key],lo,hi,base[key]);
      result.wave = Math.round(result.wave);
      return result;
    }) };
}
